import { ReactNode } from 'react';
import BgNsLandmark from '@britishgasenergy/react-nucleus/dist/nuc-components/NsLandmark';

type NsLandmarkProps = {
  type?: 'summit' | 'hillside' | 'lakeside' | 'valley';
  pillOverImage?: boolean;
  decoration?:
    | 'cyan'
    | 'lime'
    | 'navy'
    | 'blue'
    | 'forest'
    | 'orange'
    | 'red'
    | 'yellow';
  image?: string;
  heading?: ReactNode;
  subHeading?: ReactNode;
  action?: ReactNode; // TODO: enforce it to be NsPrimaryCta, NsSecondaryCta or NsForm
  ratio?: '16x9' | '4x3';
  testId?: string;
  children?: ReactNode;
};

export const NsLandmark = ({
  type = 'summit',
  pillOverImage = false,
  decoration,
  image,
  heading,
  subHeading,
  action,
  ratio,
  testId,
  children
}: NsLandmarkProps) => {
  const hasHeadings = heading || subHeading;
  return (
    <BgNsLandmark
      type={type}
      decoration={decoration}
      image={image}
      pillOverImage={pillOverImage}
      ratio={ratio}
      data-testid={testId}
    >
      {hasHeadings && (
        <h1 slot="heading">
          {subHeading && <span className="h5">{subHeading}</span>}
          {heading && <span className="h1">{heading}</span>}
        </h1>
      )}
      <div slot="paragraph">{children}</div>
      {action && <div slot="action">{action}</div>}
    </BgNsLandmark>
  );
};
